import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./VoyahCourageSpec.css";

import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahCourageSpec = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  const { currentLang } = useContext(LanguageContext);

  const toggle = (i) => {
    setOpenIndex((prev) => (prev === i ? null : i));
  };

  // =======================
  //      FETCH DATA
  // =======================
  useEffect(() => {
    const fetchSpecs = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/VoyahCourageSpec?lang=${currentLang}`
        );
        setSections(res.data);
      } catch (err) {
        console.error("Error fetching spec data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSpecs();
  }, [currentLang]); // refetch when language changes

  if (loading) return <div className="vc-loading">Loading specifications...</div>;

  return (
    <section className="vc-spec">

      {/* TITLE */}
      <h1 className="vc-title">
        {currentLang === "ar"
          ? "جميع المعلومات التي تحتاجها"
          : currentLang === "ku"
          ? "هەموو زانیارییەکان کە پێویستە"
          : "All the information you need"}
      </h1>

      {/* TABS */}
      <div className="vc-tabs">
        <div className="vc-tab">
          {currentLang === "ar"
            ? "الدفع الثنائي"
            : currentLang === "ku"
            ? "2WD"
            : "2WD"}
        </div>

        <div className="vc-tab">
          {currentLang === "ar"
            ? "الدفع الرباعي"
            : currentLang === "ku"
            ? "4WD"
            : "4WD"}
        </div>
      </div>

      {/* ACCORDION */}
      <div className="accordion border-none" id="vcAccordion">
        {sections.map((section, index) => (
          <div className="accordion-item vc-item" key={section.id}>

            {/* HEADER */}
            <h2 className="accordion-header">
              <button
                className={`accordion-button vc-header ${
                  openIndex === index ? "" : "collapsed"
                }`}
                type="button"
                onClick={() => toggle(index)}
              >
                {section.title}
              </button>
            </h2>

            {/* BODY */}
            <div
              className={`accordion-collapse collapse ${
                openIndex === index ? "show" : ""
              }`}
            >
              <div className="accordion-body p-0">

                <table className="vc-table">
                  <tbody>
                    {section.rows.map((row) => (
                      <tr key={row.id}>
                        <td className="label">{row.label}</td>
                        <td className="value">{row.twoWdValue}</td>
                        <td className="value">{row.fourWdValue}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            </div>

          </div>
        ))}
      </div>

      <p className="vc-note">
        {currentLang === "ar"
          ? "جميع المواصفات والأسعار والصور المعروضة قابلة للتغيير دون إشعار مسبق."
          : currentLang === "ku"
          ? "هەموو تایبەتمەندی، نرخ و وێنەکان دەتوانن بگۆڕدرێن بێ ئاگاداری."
          : "All specifications, prices and images on this website are indicative and are subject to change without notice."}
      </p>

    </section>
  );
};

export default VoyahCourageSpec;
